import { render } from "./DocumentClassFieldsSubView.vue?vue&type=template&id=7bda26c5&ts=true"
import script from "./DocumentClassFieldsSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassFieldsSubView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__